import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import {
  PreviewList,
  driversPreviewListModel,
} from '~/features/common/Drivers/PreviewList'
import { AddDriver } from '~/features/russia/Drivers/AddDriver'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'drivers', link: '/drivers' },
  { titleI18n: 'creating a driver' },
]

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'basic info', anchor: 'main' },
  { labelI18n: 'passport', anchor: 'passport' },
  { labelI18n: 'foreign Citizens', anchor: 'foreigners' },
  { labelI18n: 'driver license', anchor: 'drivingLicense' },
  { labelI18n: 'additional information', anchor: 'extra' },
]

export function AddDriverPageRussia() {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('adding a new driver')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('adding a new driver')}</PageTitle>
      </Container>

      <Grid container spacing={2}>
        <Grid xs={8.5}>
          <AddDriver onChange={driversPreviewListModel.filtersChanged} />
        </Grid>
        <Grid xs={3.5}>
          <PreviewList />
        </Grid>
      </Grid>

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
